import NotificationIcon from './notification-icon.vue';
import UserIcon from './user-icon.vue';
import LockIcon from './lock-icon.vue';
import MailIcon from './mail-icon.vue';
import LeftChevronD from './chevron-left-double.vue';

export enum iconN {
    NOTIFICATION = 'notification',
    USER = 'user',
    LOCK = 'lock',
    MAIL = 'mail',
    LFCHEVRON = 'lfChevron',
}

export const IconMapper = {
    notification: NotificationIcon,
    user: UserIcon,
    lock: LockIcon,
    mail: MailIcon,
    lfChevron: LeftChevronD
}

